import { useMemo, useState } from 'react';

import { Dimensions, Metrics, SortOrder, Sources } from 'components/insights/constants';
import { useInsightsContext } from 'components/insights/InsightsContainer';
import { getInitialDimensions, withDimensionIds } from 'components/insights/layout/details/helpers/dimensionsUtils';
import MetricBackArrow from 'components/insights/layout/details/MetricBackArrow';
import MetricDetailControlBar from 'components/insights/layout/details/MetricDetailControlBar';
import Separator from 'components/insights/layout/Separator';
import useAnalytics from 'components/insights/query/useAnalytics';

import ComparePriorPeriodToggle from '../ComparePriorPeriodToggle';

import AverageLengthOfStayChart from './AverageLengthOfStayChart';
import AverageLengthOfStayDataTable from './AverageLengthOfStayDataTable';
import LengthOfStayPatientTable from './LengthOfStayPatientTable';

const AverageLengthOfStayDetail = () => {
  const { profile } = useInsightsContext();

  const [selectedDimensions, setSelectedDimensions] = useState<Dimensions[]>(
    getInitialDimensions(profile.canActAsManager)
  );

  const requestParams = useMemo(
    () => ({
      source: Sources.LOCATION_EPISODE_DISCHARGES,
      dimensions: withDimensionIds(selectedDimensions),
      metrics: [Metrics.LENGTH_OF_STAY_AVERAGE, Metrics.ID_COUNT],
      sortBy: `${Metrics.ID_COUNT} ${SortOrder.DESC}, ${Dimensions.GROUP_NAME} ${SortOrder.DESC}`,
      rollups: true,
    }),
    [selectedDimensions]
  );

  const analyticsResponse = useAnalytics(requestParams);

  return (
    <>
      <MetricDetailControlBar>
        <MetricBackArrow />
        <Separator height='20px' />
        <ComparePriorPeriodToggle />
      </MetricDetailControlBar>
      <AverageLengthOfStayChart
        {...analyticsResponse}
        onSelectedDimensionsChange={setSelectedDimensions}
        selectedDimensions={selectedDimensions}
      />
      <AverageLengthOfStayDataTable
        {...analyticsResponse}
        requestParams={requestParams}
        onSelectedDimensionsChange={setSelectedDimensions}
        selectedDimensions={selectedDimensions}
      />
      <LengthOfStayPatientTable onSelectedDimensionsChange={setSelectedDimensions} />
    </>
  );
};

export default AverageLengthOfStayDetail;
